import { render, staticRenderFns } from "./AlarmForm.vue?vue&type=template&id=4381bc0b"
import script from "./AlarmForm.vue?vue&type=script&lang=js"
export * from "./AlarmForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports